import { FormGroup } from '@angular/forms';

export abstract class AbstractFormComponent {
  form: FormGroup;
  submitted: Boolean = false;
  constructor() { }
  resetForm() {
    this.form.reset();
  }

  onSubmit() {
    this.submitted = true;
    if (!this.form.valid) {
      this.submitted = false;
      return;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/common/abstract.component.ts